import api from "@/api/axios";

export default {
  namespaced: true,
  
  state: {
    words: [],
    loading: false,
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0
    }
  },

  mutations: {
    SET_WORDS(state, { list, total }) {
      state.words = list
      state.pagination.total = total
    },
    SET_LOADING(state, status) {
      state.loading = status
    },
    SET_PAGINATION(state, { current, pageSize }) {
      state.pagination.current = current
      state.pagination.pageSize = pageSize
    }
  },

  actions: {
    async fetchWords({ commit }, { page = 1, pageSize = 10 } = {}) {
      try {
        commit('SET_LOADING', true)
        const response = await api.get('/words/list', {
          params: { page, page_size: pageSize }
        })
        
        if (response.data.status === 200) {
          commit('SET_WORDS', {
            list: response.data.data.list,
            total: response.data.data.total
          })
          commit('SET_PAGINATION', {
            current: page,
            pageSize
          })
        }
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async saveWord(_, wordData) {
      const response = await api.post('/words/add', wordData)
      if (response.data.status === 200) {
        return response.data
      }
      throw new Error(response.data.msg || '保存失败')
    },
    async deleteWord(_, id) {
      const response = await api.delete(`/words/${id}`)
      if (response.data.status === 200) {
        return response.data
      }
      throw new Error(response.data.msg || '删除失败')
    }
  }
}